<template>
  <div class="navbar-page">
    <van-nav-bar
      :title="title"
      :fixed="fixed"
      :left-arrow="hasArrow"
      @click-left="$router.go(-1)"
    />
  </div>
</template>

<script>
export default {
  props: {
    fixed: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '立吉答题'
    },
    hasArrow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return{

    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.navbar-page {
  /deep/ .van-nav-bar .van-icon {
    color: #262626;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue